module.exports = __webpack_public_path__ + "../resources/img/ic_wifi_on.0076d663.svg";